import React from 'react'
import PropTypes from 'prop-types'
import {
  CheckIconWrapper,
  ErrorText,
  FieldWrapper,
  HeaderText,
  HiddenCheckbox,
  Label,
  QuestionText,
  QuestionWrapper,
  RadioCircle,
  RadioField,
  SelectionsWrapper,
  StyledCheckbox,
  StyledCheckIcon,
  StyledWarningIcon,
  StyledHr,
} from './component.styles'

const AddImplementationApproach = ({
  errors,
  handleChange,
  handleSubmit,
  modalData,
  touched,
  values,
}) => {
  const { header, choiceContent } = modalData
  return (
    <form onSubmit={handleSubmit}>
      <HeaderText>{header}</HeaderText>
      <QuestionWrapper>
        <QuestionText>{choiceContent[0].questionText}</QuestionText>
        <StyledHr />
        <SelectionsWrapper>
          <FieldWrapper>
            <RadioField
              checked={values.ImplementationType === 'Pilot'}
              id="Pilot"
              name="ImplementationType"
              type="radio"
              value="Pilot"
            />
            <RadioCircle htmlFor="Pilot" />
            <Label for="Pilot">{choiceContent[0].answerChoice1}</Label>
          </FieldWrapper>
          <FieldWrapper>
            <RadioField
              checked={values.ImplementationType === 'SchoolWide'}
              id="SchoolWide"
              name="ImplementationType"
              type="radio"
              value="SchoolWide"
            />
            <RadioCircle htmlFor="SchoolWide" />
            <Label for="SchoolWide">{choiceContent[0].answerChoice2}</Label>
          </FieldWrapper>
        </SelectionsWrapper>
        {touched.implementationType && errors.implementationType && (
          <ErrorText>
            <StyledWarningIcon />
            {errors.implementationType}
          </ErrorText>
        )}
      </QuestionWrapper>
      <QuestionWrapper>
        <QuestionText>{choiceContent[1].questionText}</QuestionText>
        <StyledHr />
        <SelectionsWrapper>
          <FieldWrapper>
            <HiddenCheckbox
              checked={values.TeacherLed}
              id="TeacherLed"
              name="TeacherLed"
              onChange={e => handleChange('TeacherLed', e.target.checked)}
              type="checkbox"
            />
            <StyledCheckbox htmlFor="TeacherLed">
              <CheckIconWrapper>
                <StyledCheckIcon />
              </CheckIconWrapper>
            </StyledCheckbox>
            <Label for="TeacherLed">{choiceContent[1].answerChoice1}</Label>
          </FieldWrapper>
          <FieldWrapper>
            <HiddenCheckbox
              checked={values.CounselorLed}
              id="CounselorLed"
              name="CounselorLed"
              onChange={e => handleChange('CounselorLed', e.target.checked)}
              type="checkbox"
            />
            <StyledCheckbox htmlFor="CounselorLed">
              <CheckIconWrapper>
                <StyledCheckIcon />
              </CheckIconWrapper>
            </StyledCheckbox>
            <Label for="CounselorLed">{choiceContent[1].answerChoice2}</Label>
          </FieldWrapper>
        </SelectionsWrapper>
        {(touched.CounselorLed || touched.TeacherLed) &&
          (errors.CounselorLed || errors.TeacherLed) && (
            <ErrorText>
              <StyledWarningIcon />
              {errors.CounselorLed ? errors.CounselorLed : errors.TeacherLed}
            </ErrorText>
          )}
      </QuestionWrapper>
    </form>
  )
}

AddImplementationApproach.propTypes = {
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  modalData: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
}

export default AddImplementationApproach
